import { render, staticRenderFns } from "./ListResponsavelHistoricoSmsView.vue?vue&type=template&id=09d09bdb&"
import script from "./ListResponsavelHistoricoSmsView.vue?vue&type=script&lang=ts&"
export * from "./ListResponsavelHistoricoSmsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports